var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen",value:(_vm.loginLoad),expression:"loginLoad",modifiers:{"fullscreen":true}}],staticClass:"login-for-sso",attrs:{"element-loading-text":"正在登录认证中..."}})])
}
var staticRenderFns = []

export { render, staticRenderFns }